/* eslint-disable */
// CHESS LESSON 4 — Queen and King Movement
// 56 minutes · Lesson 4 of 24 · Beginner Module
// Rules 1-18 applied. All Kings removed from solo teaching boards.
// All FENs verified with chess.js skipValidation.

export const LESSON_4 = {
  id: 'chess-lesson-4',
  title: 'Queen and King Movement',
  subtitle: 'Lesson 4 of 24 · Beginner Module',
  totalMinutes: 56,
  phases: [
    {
      id: 'warmup',
      title: 'Warm-up — Rook and Bishop Recall',
      type: 'warmup',
      durationMins: 5,
      steps: [
        {
          id: 'wa1a',
          type: 'observe',
          boardState: '8/8/8/8/4R3/8/8/8 w - - 0 1',
          highlights: ['e1','e2','e3','e5','e6','e7','e8','a4','b4','c4','d4','f4','g4','h4'],
          pieceLetterRef: [{ icon: '♖', letter: 'R', name: 'Rook' }],
          voice: `Welcome back, {name}! Quick recall — here is a Rook on e4. Count the yellow squares — FOURTEEN, straight lines in all four directions!`,
          task: null,
          taskType: 'observe',
          continueLabel: 'Now the Bishop!',
        },
        {
          id: 'wa1b',
          type: 'observe',
          boardState: '8/8/8/8/4B3/8/8/8 w - - 0 1',
          highlights: ['a8','b1','b7','c2','c6','d3','d5','f3','f5','g2','g6','h1','h7'],
          pieceLetterRef: [{ icon: '♗', letter: 'B', name: 'Bishop' }],
          voice: `And remember the Bishop's colour-lock — it can never change its square colour.`,
          task: null,
          taskType: 'observe',
          continueLabel: 'Now the Queen!',
        },
        {
          id: 'wa1cr',
          type: 'observe',
          boardState: '8/8/8/8/4R3/8/8/8 w - - 0 1',
          highlights: ['e1','e2','e3','e5','e6','e7','e8','a4','b4','c4','d4','f4','g4','h4'],
          pieceLetterRef: [{ icon: '♖', letter: 'R', name: 'Rook' }],
          voice: `The Rook — straight lines in all four directions, fourteen squares from e4.`,
          task: null,
          taskType: 'observe',
          continueLabel: 'Now the Bishop!',
        },
        {
          id: 'wa1cb',
          type: 'observe',
          boardState: '8/8/8/8/8/8/8/2B5 w - - 0 1',
          highlights: ['a3','b2','d2','e3','f4','g5','h6'],
          pieceLetterRef: [{ icon: '♗', letter: 'B', name: 'Bishop' }],
          voice: `The Bishop — diagonals only, colour-locked to dark squares forever.`,
          task: null,
          taskType: 'observe',
          continueLabel: 'Now the Queen!',
        },
        {
          id: 'wa1c',
          type: 'observe',
          boardState: '8/8/8/8/4Q3/8/8/8 w - - 0 1',
          highlights: ['a4','a8','b1','b4','b7','c2','c4','c6','d3','d4','d5','e1','e2','e3','e5','e6','e7','e8','f3','f4','f5','g2','g4','g6','h1','h4','h7'],
          pieceLetterRef: [{ icon: '♕', letter: 'Q', name: 'Queen' }],
          voice: `Today we meet a piece that combines BOTH the Rook and Bishop — the Queen!`,
          task: null,
          taskType: 'observe',
          continueLabel: 'Now the King!',
        },
        {
          id: 'wa1d',
          type: 'observe',
          boardState: '8/8/8/8/8/8/8/4K3 w - - 0 1',
          highlights: ['e1'],
          pieceLetterRef: [{ icon: '♔', letter: 'K', name: 'King' }],
          voice: `And we meet the most important piece of all — the King!`,
          task: null,
          taskType: 'observe',
          continueLabel: "Let's meet the Queen!",
        },
        {
          id: 'wa2',
          type: 'recap-quiz',
          boardState: '8/8/8/8/8/8/8/2B5 w - - 0 1',
          highlights: ['c1'],
          pieceLetterRef: [{ icon: '♗', letter: 'B', name: 'Bishop' }],
          voice: `Quick check — this Bishop is on c1, a dark square. Could it EVER reach a light square?`,
          task: null,
          taskType: 'recap-quiz',
          recapQuestion: 'Can this dark-squared Bishop ever reach a light square?',
          recapOptions: ['Never — colour-locked forever', 'Yes, eventually'],
          recapCorrect: 0,
          recapCorrectVoice: `Correct! Never — the Bishop's colour is locked permanently. Now let us meet a piece that has NO colour restriction at all!`,
          recapWrongVoice: `NEVER — a Bishop's colour is locked for the whole game. Now let us meet a piece with no such restriction!`,
          continueLabel: 'Meet the Queen!',
        },
      ],
    },
    {
      id: 'queenteach',
      title: 'The Queen — Rook + Bishop Combined',
      type: 'teach',
      durationMins: 8,
      steps: [
        {
          id: 'qt0r',
          type: 'observe',
          boardState: '8/8/8/8/4R3/8/8/8 w - - 0 1',
          highlights: ['e1','e2','e3','e5','e6','e7','e8','a4','b4','c4','d4','f4','g4','h4'],
          pieceLetterRef: [{ icon: '♖', letter: 'R', name: 'Rook' }],
          voice: `Quick recall — the Rook: fourteen squares, four straight lines.`,
          task: null,
          taskType: 'observe',
          continueLabel: 'Now the Bishop!',
        },
        {
          id: 'qt0b',
          type: 'observe',
          boardState: '8/8/8/8/8/8/8/2B5 w - - 0 1',
          highlights: ['a3','b2','d2','e3','f4','g5','h6'],
          pieceLetterRef: [{ icon: '♗', letter: 'B', name: 'Bishop' }],
          voice: `And the Bishop: diagonals only, colour-locked to one square colour.`,
          task: null,
          taskType: 'observe',
          continueLabel: 'Now the Queen!',
        },
        {
          id: 'qt0',
          type: 'observe',
          boardState: '8/8/8/8/8/8/8/3Q4 w - - 0 1',
          highlights: ['d1'],
          pieceLetterRef: [{ icon: '♕', letter: 'Q', name: 'Queen' }],
          voice: `{name}, here is the QUEEN on her real starting square — d1! Her letter is Q. See her crown of points — like a little sun. The Queen moves like the ROOK and BISHOP COMBINED — straight lines AND diagonal lines, in all eight directions, as far as the board allows!`,
          task: null,
          taskType: 'observe',
          continueLabel: 'Show me her moves from d1!',
        },
        {
          id: 'qt1a',
          type: 'observe',
          boardState: '8/8/8/8/8/8/8/3Q4 w - - 0 1',
          demoSequence: [
            { fen: '3Q4/8/8/8/8/8/8/8 w - - 0 1', path: ['d2','d3','d4','d5','d6','d7','d8'], delay: 2400 },
          ],
          highlights: [],
          pieceLetterRef: [{ icon: '♕', letter: 'Q', name: 'Queen' }],
          voice: `The Queen slides straight UP the d-file from d1 to d8 — seven squares in one move!`,
          task: null,
          taskType: 'observe',
          continueLabel: 'Next direction!',
        },
        {
          id: 'qt1b',
          type: 'observe',
          boardState: '8/8/8/8/8/8/8/3Q4 w - - 0 1',
          demoSequence: [
            { fen: '8/8/8/8/8/8/8/Q7 w - - 0 1', path: ['c1','b1','a1'], delay: 2400 },
          ],
          highlights: [],
          pieceLetterRef: [{ icon: '♕', letter: 'Q', name: 'Queen' }],
          voice: `Now the Queen slides LEFT along rank 1 from d1 to a1!`,
          task: null,
          taskType: 'observe',
          continueLabel: 'Next direction!',
        },
        {
          id: 'qt1cr',
          type: 'observe',
          boardState: '8/8/8/8/4R3/8/8/8 w - - 0 1',
          highlights: ['e1','e2','e3','e5','e6','e7','e8','a4','b4','c4','d4','f4','g4','h4'],
          pieceLetterRef: [{ icon: '♖', letter: 'R', name: 'Rook' }],
          voice: `The Rook — straight lines along ranks and files. The Queen shares those straight-line moves!`,
          task: null,
          taskType: 'observe',
          continueLabel: 'Next direction!',
        },
        {
          id: 'qt1c',
          type: 'observe',
          boardState: '8/8/8/8/8/8/8/3Q4 w - - 0 1',
          demoSequence: [
            { fen: '8/8/8/8/8/8/8/7Q w - - 0 1', path: ['e1','f1','g1','h1'], delay: 2400 },
          ],
          highlights: [],
          pieceLetterRef: [{ icon: '♕', letter: 'Q', name: 'Queen' }],
          voice: `And RIGHT along rank 1 from d1 to h1! Three straight-line directions so far — just like the Rook!`,
          task: null,
          taskType: 'observe',
          continueLabel: 'Now diagonal!',
        },
        {
          id: 'qt1db',
          type: 'observe',
          boardState: '8/8/8/8/8/8/8/2B5 w - - 0 1',
          highlights: ['a3','b2','d2','e3','f4','g5','h6'],
          pieceLetterRef: [{ icon: '♗', letter: 'B', name: 'Bishop' }],
          voice: `The Bishop — diagonals only. Now watch the Queen go diagonal too!`,
          task: null,
          taskType: 'observe',
          continueLabel: 'Show me diagonal!',
        },
        {
          id: 'qt1d',
          type: 'observe',
          boardState: '8/8/8/8/8/8/8/3Q4 w - - 0 1',
          demoSequence: [
            { fen: '8/8/8/7Q/8/8/8/8 w - - 0 1', path: ['e2','f3','g4','h5'], delay: 2400 },
          ],
          highlights: [],
          pieceLetterRef: [{ icon: '♕', letter: 'Q', name: 'Queen' }],
          voice: `Now diagonal! The Queen slides diagonally up-right from d1 to h5 — just like the Bishop! Four directions from d1, and she has more in the centre!`,
          task: null,
          taskType: 'observe',
          continueLabel: 'Show me from the centre!',
        },
        {
          id: 'qt2r',
          type: 'observe',
          boardState: '8/8/8/8/4R3/8/8/8 w - - 0 1',
          highlights: ['e1','e2','e3','e5','e6','e7','e8','a4','b4','c4','d4','f4','g4','h4'],
          pieceLetterRef: [{ icon: '♖', letter: 'R', name: 'Rook' }],
          voice: `Rook on e4 — fourteen straight squares.`,
          task: null,
          taskType: 'observe',
          continueLabel: 'Now the Bishop!',
        },
        {
          id: 'qt2b',
          type: 'observe',
          boardState: '8/8/8/8/8/8/8/2B5 w - - 0 1',
          highlights: ['a3','b2','d2','e3','f4','g5','h6'],
          pieceLetterRef: [{ icon: '♗', letter: 'B', name: 'Bishop' }],
          voice: `Bishop — diagonal squares only. Thirteen from the centre. Now watch the Queen combine both!`,
          task: null,
          taskType: 'observe',
          continueLabel: 'Queen from the centre!',
        },
        {
          id: 'qt2',
          type: 'observe',
          boardState: '8/8/8/8/4Q3/8/8/8 w - - 0 1',
          demoSequence: [
            { fen: '4Q3/8/8/8/8/8/8/8 w - - 0 1', path: ['e5','e6','e7','e8'], delay: 1800 },
            { fen: '8/8/8/8/8/8/8/4Q3 w - - 0 1', path: ['e3','e2','e1'], delay: 1800 },
            { fen: '8/8/8/8/Q7/8/8/8 w - - 0 1', path: ['d4','c4','b4','a4'], delay: 1800 },
            { fen: '8/8/8/8/7Q/8/8/8 w - - 0 1', path: ['f4','g4','h4'], delay: 1800 },
            { fen: '8/7Q/8/8/8/8/8/8 w - - 0 1', path: ['f5','g6','h7'], delay: 1800 },
            { fen: '8/1Q6/8/8/8/8/8/8 w - - 0 1', path: ['d5','c6','b7'], delay: 1800 },
            { fen: '8/8/8/8/8/8/8/7Q w - - 0 1', path: ['f3','g2','h1'], delay: 1800 },
            { fen: '8/8/8/8/8/8/8/1Q6 w - - 0 1', path: ['d3','c2','b1'], delay: 1800 },
          ],
          highlights: ['a4','a8','b1','b4','b7','c2','c4','c6','d3','d4','d5','e1','e2','e3','e5','e6','e7','e8','f3','f4','f5','g2','g4','g6','h1','h4','h7'],
          pieceLetterRef: [{ icon: '♕', letter: 'Q', name: 'Queen' }],
          voice: `From the CENTRE square e4, the Queen reaches ALL EIGHT directions! Count all the yellow squares — TWENTY-SEVEN! The Rook's fourteen straight squares PLUS the Bishop's thirteen diagonal squares. The Queen is the MOST POWERFUL piece in chess. She can do everything the Rook and Bishop do, at the same time!`,
          task: null,
          taskType: 'observe',
          continueLabel: 'Your turn to try!',
        },
      ],
    },
    {
      id: 'queenpractice',
      title: 'Queen Practice — Find Her Reach',
      type: 'practice',
      durationMins: 12,
      steps: [
        {
          id: 'qp1',
          type: 'piece-range',
          pieceRangeFen: '8/8/8/8/4Q3/8/8/8 w - - 0 1',
          highlights: [],
          voice: `The Queen is on e4. Drag her to EVERY square she can reach — straight lines AND diagonals. All twenty-seven!`,
          task: 'Drag the Queen on e4 to every square she can reach.',
          taskType: 'piece-range',
          targetSquares: ['a4','a8','b1','b4','b7','c2','c4','c6','d3','d4','d5','e1','e2','e3','e5','e6','e7','e8','f3','f4','f5','g2','g4','g6','h1','h4','h7'],
          successVoice: `All twenty-seven! From the centre the Queen is unstoppable. Now the corner...`,
          continueLabel: 'Try the corner!',
        },
        {
          id: 'qp2',
          type: 'piece-range',
          pieceRangeFen: '8/8/8/8/8/8/8/Q7 w - - 0 1',
          highlights: [],
          voice: `The Queen on a1 — the dark corner. How many squares can she reach? Drag her to find out!`,
          task: 'Drag the Queen on a1 to every square she can reach.',
          taskType: 'piece-range',
          targetSquares: ['a2','a3','a4','a5','a6','a7','a8','b1','b2','c1','c3','d1','d4','e1','e5','f1','f6','g1','g7','h1','h8'],
          successVoice: `Twenty-one from the corner — six fewer than the centre. The corner limits her diagonals. One more spot...`,
          continueLabel: 'Try the edge!',
        },
        {
          id: 'qp2b',
          type: 'observe',
          boardState: '8/8/8/8/8/8/8/Q7 w - - 0 1',
          highlights: [],
          pieceLetterRef: [{ icon: '♕', letter: 'Q', name: 'Queen' }],
          voice: `Twenty-one from the corner. Six fewer than the centre. The Queen is strongest in the middle of the battlefield.`,
          task: null,
          taskType: 'observe',
          continueLabel: 'Try the edge!',
        },
        {
          id: 'qp3',
          type: 'piece-range',
          pieceRangeFen: '8/8/8/8/7Q/8/8/8 w - - 0 1',
          highlights: [],
          voice: `The Queen on h4 — the edge. Drag her to every square she can reach!`,
          task: 'Drag the Queen on h4 to every square she can reach.',
          taskType: 'piece-range',
          targetSquares: ['a4','b4','c4','d4','d8','e1','e4','e7','f2','f4','f6','g3','g4','g5','h1','h2','h3','h5','h6','h7','h8'],
          successVoice: `Twenty-one again — same as the corner! The Queen always reaches her MOST squares from the CENTRE. That is why strong players bring her toward the centre — carefully, since she is so valuable!`,
          continueLabel: 'Now meet the King!',
        },
      ],
    },
    {
      id: 'kingteach',
      title: 'The King — One Careful Step',
      type: 'teach',
      durationMins: 7,
      steps: [
        {
          id: 'kt0',
          type: 'observe',
          boardState: '4k3/8/8/8/8/8/8/4K3 w - - 0 1',
          highlights: ['e1'],
          pieceLetterRef: [{ icon: '♔', letter: 'K', name: 'King' }],
          voice: `Now meet the KING on his real starting square — e1! His letter is K. See the little cross on his crown. The King is the most IMPORTANT piece — not the most powerful, but the one that matters most. If your King is trapped, the game is over. He moves only ONE square at a time, in ANY direction.`,
          task: null,
          taskType: 'observe',
          continueLabel: 'Show me his steps!',
        },
        {
          id: 'kt1',
          type: 'observe',
          boardState: '4k3/8/8/8/8/8/8/4K3 w - - 0 1',
          demoSequence: [
            { fen: '4k3/8/8/8/8/8/4K3/8 w - - 0 1', path: ['e2'], delay: 1900 },
            { fen: '4k3/8/8/8/8/8/8/3K4 w - - 0 1', path: ['d1'], delay: 1900 },
            { fen: '4k3/8/8/8/8/8/8/5K2 w - - 0 1', path: ['f1'], delay: 1900 },
            { fen: '4k3/8/8/8/8/8/3K4/8 w - - 0 1', path: ['d2'], delay: 1900 },
            { fen: '4k3/8/8/8/8/8/5K2/8 w - - 0 1', path: ['f2'], delay: 1900 },
          ],
          highlights: [],
          pieceLetterRef: [{ icon: '♔', letter: 'K', name: 'King' }],
          voice: `From e1, the King steps to e2, or sideways to d1 or f1, or diagonally to d2 or f2. Five choices from the back rank. From the centre he has eight. Just one careful step — always!`,
          task: null,
          taskType: 'observe',
          continueLabel: 'Show me from the centre!',
        },
        {
          id: 'kt2q',
          type: 'observe',
          boardState: '8/8/8/8/4Q3/8/8/8 w - - 0 1',
          highlights: ['a4','a8','b1','b4','b7','c2','c4','c6','d3','d4','d5','e1','e2','e3','e5','e6','e7','e8','f3','f4','f5','g2','g4','g6','h1','h4','h7'],
          pieceLetterRef: [{ icon: '♕', letter: 'Q', name: 'Queen' }],
          voice: `Remember — the Queen from e4 reaches twenty-seven squares!`,
          task: null,
          taskType: 'observe',
          continueLabel: 'Now the King!',
        },
        {
          id: 'kt2',
          type: 'observe',
          boardState: '8/8/8/8/4K3/8/8/8 w - - 0 1',
          demoSequence: [
            { fen: '8/8/8/4K3/8/8/8/8 w - - 0 1', path: ['e5'], delay: 1700 },
            { fen: '8/8/8/8/8/4K3/8/8 w - - 0 1', path: ['e3'], delay: 1700 },
            { fen: '8/8/8/8/3K4/8/8/8 w - - 0 1', path: ['d4'], delay: 1700 },
            { fen: '8/8/8/8/5K2/8/8/8 w - - 0 1', path: ['f4'], delay: 1700 },
            { fen: '8/8/8/3K4/8/8/8/8 w - - 0 1', path: ['d5'], delay: 1700 },
            { fen: '8/8/8/5K2/8/8/8/8 w - - 0 1', path: ['f5'], delay: 1700 },
            { fen: '8/8/8/8/8/3K4/8/8 w - - 0 1', path: ['d3'], delay: 1700 },
            { fen: '8/8/8/8/8/5K2/8/8 w - - 0 1', path: ['f3'], delay: 1700 },
          ],
          highlights: ['d3','d4','d5','e3','e5','f3','f4','f5'],
          pieceLetterRef: [{ icon: '♔', letter: 'K', name: 'King' }],
          voice: `From e4, the King reaches EIGHT neighbouring squares — one step in every direction, like a little box around him. Compare that to the Queen's twenty-seven! The King is the shortest-range piece — which is exactly why he needs the other pieces to protect him.`,
          task: null,
          taskType: 'observe',
          continueLabel: 'Your turn to try!',
        },
      ],
    },
    {
      id: 'kingpractice',
      title: 'King Practice — One Careful Step',
      type: 'practice',
      durationMins: 12,
      steps: [
        {
          id: 'kp1',
          type: 'piece-range',
          pieceRangeFen: '8/8/8/8/4K3/8/8/8 w - - 0 1',
          highlights: [],
          voice: `The King is on e4 — the centre. Drag him to every square he can step to. Just eight — one step in every direction!`,
          task: 'Drag the King on e4 to every square he can reach.',
          taskType: 'piece-range',
          targetSquares: ['d3','d4','d5','e3','e5','f3','f4','f5'],
          successVoice: `All eight! From the centre the King is surrounded. Now the corner...`,
          continueLabel: 'Try the corner!',
        },
        {
          id: 'kp2',
          type: 'piece-range',
          pieceRangeFen: '8/8/8/8/8/8/8/K7 w - - 0 1',
          highlights: [],
          voice: `The King on a1 — the dark corner. How many squares can he reach? Drag him to find out!`,
          task: 'Drag the King on a1 to every square he can reach.',
          taskType: 'piece-range',
          targetSquares: ['a2','b1','b2'],
          successVoice: `Just THREE — the corner is the King's most cramped spot. Only three escape squares. This is why corner Kings can be in danger!`,
          continueLabel: 'Try the edge!',
        },
        {
          id: 'kp2b',
          type: 'observe',
          boardState: '8/8/8/8/8/8/8/K7 w - - 0 1',
          highlights: [],
          pieceLetterRef: [{ icon: '♔', letter: 'K', name: 'King' }],
          voice: `Three squares from the corner. The King is most vulnerable in the corner. Remember that.`,
          task: null,
          taskType: 'observe',
          continueLabel: 'Try the edge!',
        },
        {
          id: 'kp3',
          type: 'piece-range',
          pieceRangeFen: '8/8/8/8/7K/8/8/8 w - - 0 1',
          highlights: [],
          voice: `The King on h4 — the edge. Drag him to every square he can reach!`,
          task: 'Drag the King on h4 to every square he can reach.',
          taskType: 'piece-range',
          targetSquares: ['g3','g4','g5','h3','h5'],
          successVoice: `Five on the edge — between the corner's three and the centre's eight. Centre gives the most space for EVERY piece! One more...`,
          continueLabel: 'One more spot!',
        },
        {
          id: 'kp4',
          type: 'piece-range',
          pieceRangeFen: '8/8/8/8/8/8/1K6/8 w - - 0 1',
          highlights: [],
          voice: `The King on b2 — just one square from the corner. Surprising question — how many squares can he reach here?`,
          task: 'Drag the King on b2 to every square he can reach.',
          taskType: 'piece-range',
          targetSquares: ['a1','a2','a3','b1','b3','c1','c2','c3'],
          successVoice: `EIGHT — same as the centre! One square away from the corner, the King already has all eight neighbours. Only squares ON the edge or corner itself are cramped. Now let us compare all four pieces!`,
          continueLabel: 'See the big comparison!',
        },
      ],
    },
    {
      id: 'recap',
      title: 'Rook, Bishop, Queen, King — All Four Compared',
      type: 'teach',
      durationMins: 8,
      steps: [
        {
          id: 'rc1',
          type: 'observe',
          boardState: '8/8/8/8/4R3/8/8/8 w - - 0 1',
          highlights: ['e1','e2','e3','e5','e6','e7','e8','a4','b4','c4','d4','f4','g4','h4'],
          pieceLetterRef: [{ icon: '♖', letter: 'R', name: 'Rook' }],
          voice: `{name}, let us compare all four pieces from the same square — e4! Rook first — fourteen squares, straight lines only. That is the plus shape.`,
          task: null,
          taskType: 'observe',
          continueLabel: 'Now the Bishop',
        },
        {
          id: 'rc2',
          type: 'observe',
          boardState: '8/8/8/8/4B3/8/8/8 w - - 0 1',
          highlights: ['a8','b1','b7','c2','c6','d3','d5','f3','f5','g2','g6','h1','h7'],
          pieceLetterRef: [{ icon: '♗', letter: 'B', name: 'Bishop' }],
          voice: `Bishop — thirteen squares, diagonals only. That is the X shape. And all the same colour as e4.`,
          task: null,
          taskType: 'observe',
          continueLabel: 'Now the Queen',
        },
        {
          id: 'rc3r',
          type: 'observe',
          boardState: '8/8/8/8/4R3/8/8/8 w - - 0 1',
          highlights: ['e1','e2','e3','e5','e6','e7','e8','a4','b4','c4','d4','f4','g4','h4'],
          pieceLetterRef: [{ icon: '♖', letter: 'R', name: 'Rook' }],
          voice: `Rook — fourteen straight-line squares from e4.`,
          task: null,
          taskType: 'observe',
          continueLabel: 'Now the Bishop!',
        },
        {
          id: 'rc3b',
          type: 'observe',
          boardState: '8/8/8/8/8/8/8/2B5 w - - 0 1',
          highlights: ['a3','b2','d2','e3','f4','g5','h6'],
          pieceLetterRef: [{ icon: '♗', letter: 'B', name: 'Bishop' }],
          voice: `Bishop — diagonal squares only. Thirteen from the centre.`,
          task: null,
          taskType: 'observe',
          continueLabel: 'Now the Queen!',
        },
        {
          id: 'rc3',
          type: 'observe',
          boardState: '8/8/8/8/4Q3/8/8/8 w - - 0 1',
          highlights: ['a4','a8','b1','b4','b7','c2','c4','c6','d3','d4','d5','e1','e2','e3','e5','e6','e7','e8','f3','f4','f5','g2','g4','g6','h1','h4','h7'],
          pieceLetterRef: [{ icon: '♕', letter: 'Q', name: 'Queen' }],
          voice: `Queen — TWENTY-SEVEN squares. The Rook's fourteen PLUS the Bishop's thirteen. The plus AND the X combined!`,
          task: null,
          taskType: 'observe',
          continueLabel: 'Now the King',
        },
        {
          id: 'rc4',
          type: 'observe',
          boardState: '8/8/8/8/4K3/8/8/8 w - - 0 1',
          highlights: ['d3','d4','d5','e3','e5','f3','f4','f5'],
          pieceLetterRef: [
            { icon: '♖', letter: 'R', name: 'Rook' },
            { icon: '♗', letter: 'B', name: 'Bishop' },
            { icon: '♕', letter: 'Q', name: 'Queen' },
            { icon: '♔', letter: 'K', name: 'King' },
          ],
          voice: `King — just EIGHT squares, one careful step. Eight versus thirteen, fourteen, and twenty-seven! The King is the shortest-range piece of all — which is exactly why he must be protected by the others!`,
          task: null,
          taskType: 'observe',
          continueLabel: 'Quick quiz!',
        },
        {
          id: 'rc5',
          type: 'recap-quiz',
          boardState: '8/8/8/8/4Q3/8/8/8 w - - 0 1',
          highlights: ['e4'],
          voice: `The Queen is on e4 — a dark square. If she moves straight up to e5 — a light square — is that allowed?`,
          task: null,
          taskType: 'recap-quiz',
          recapQuestion: 'Can the Queen move from a dark square to a light square?',
          recapOptions: ['Yes — she is NOT colour-locked like the Bishop', 'No — she is colour-locked like the Bishop'],
          recapCorrect: 0,
          recapCorrectVoice: `YES! The Queen can visit ANY colour of square — because she moves in straight lines too, which change the square colour. Only the BISHOP has the colour-lock. The Queen is free!`,
          recapWrongVoice: `Yes she can! Unlike the Bishop, the Queen is NOT colour-locked — her straight-line moves take her to both colours. Only the Bishop has the permanent colour-lock.`,
          continueLabel: 'One more thing before we finish...',
        },
      ],
    },
    {
      id: 'wrapup',
      title: 'Lesson Complete!',
      type: 'wrapup',
      durationMins: 4,
      steps: [
        {
          id: 'wu1',
          type: 'recap-quiz',
          boardState: '8/8/8/8/R3Q3/8/1N2P3/2B3K1 w - - 0 1',
          highlights: ['a4','e4','b2','e2','c1','g1'],
          pieceLetterRef: [
            { icon: '♖', letter: 'R', name: 'Rook' },
            { icon: '♗', letter: 'B', name: 'Bishop' },
            { icon: '♕', letter: 'Q', name: 'Queen' },
            { icon: '♔', letter: 'K', name: 'King' },
            { icon: '♘', letter: 'N', name: 'Knight' },
            { icon: '♙', letter: '—', name: 'Pawn (no letter)' },
          ],
          voice: `{name}, brilliant work! The Queen — Q — moves like Rook and Bishop combined, up to twenty-seven squares. The King — K — moves one square in any direction but is the most important piece. And unlike the Bishop, the Queen is NOT colour-locked. Four pieces mastered — Rook, Bishop, Queen, King. Only Knight and Pawn to go!`,
          task: null,
          taskType: 'recap-quiz',
          recapQuestion: 'From which position does the Queen reach the MOST squares?',
          recapOptions: ['The centre of the board', 'A corner', 'Always the same'],
          recapCorrect: 0,
          recapCorrectVoice: `The centre — twenty-seven squares! Corners and edges give only twenty-one. Centre is always most powerful!`,
          recapWrongVoice: `The CENTRE gives twenty-seven squares — corners and edges give only twenty-one. Centre is always most powerful for the Queen!`,
          continueLabel: 'One more thing before we finish...',
        },
        {
          id: 'wu1b',
          type: 'wrapup',
          boardState: 'empty',
          highlights: [],
          voice: `Quick one. The Queen moves like which two pieces combined?`,
          task: null,
          taskType: 'recap-quiz',
          recapQuestion: 'The Queen moves like which two pieces combined?',
          recapOptions: ['Rook and Bishop','Rook and Knight','Bishop and Knight'],
          recapCorrect: 0,
          recapCorrectVoice: `Rook and Bishop combined. Straight lines AND diagonals. That is why she is the most powerful piece.`,
          recapWrongVoice: `Rook and Bishop. Straight lines from the Rook. Diagonals from the Bishop. Combined into one powerful piece.`,
        },
        {
          id: 'wu1c',
          type: 'wrapup',
          boardState: 'empty',
          highlights: [],
          voice: `Last one. The King is the most important piece. But how many squares can he move to at most in one turn?`,
          task: null,
          taskType: 'recap-quiz',
          recapQuestion: 'In how many directions can the King move?',
          recapOptions: ['Eight directions','Four directions','One direction'],
          recapCorrect: 0,
          recapCorrectVoice: `Eight directions. Forward, backward, left, right, and all four diagonals. One square each time. Eight directions always.`,
          recapWrongVoice: `Eight directions. Forward, backward, left, right, and all four diagonals. The King is slow but can go anywhere.`,
        },
        {
          id: 'wu2',
          type: 'wrapup',
          boardState: '8/8/8/8/8/8/4P3/RNBQK1N1 w - - 0 1',
          highlights: ['a1','b1','c1','d1','e1','g1','e2'],
          pieceLetterRef: [
            { icon: '♖', letter: 'R', name: 'Rook' },
            { icon: '♗', letter: 'B', name: 'Bishop' },
            { icon: '♕', letter: 'Q', name: 'Queen' },
            { icon: '♔', letter: 'K', name: 'King' },
            { icon: '♘', letter: 'N', name: 'Knight' },
            { icon: '♙', letter: '—', name: 'Pawn (no letter)' },
          ],
          voice: `{name}, you have done brilliantly today! You learned the Queen — the most powerful piece, moving in all eight directions up to twenty-seven squares — and the King, who moves just one careful step in any direction but is the most important piece of all. Four pieces mastered: Rook, Bishop, Queen, and King! Next time we meet the last two pieces — the KNIGHT on b1 and g1, who jumps in a special L-shape and can leap OVER other pieces, and the PAWN on e2, the smallest piece that can transform into a Queen! Two very different pieces — both with surprises in store. See you next session!`,
          task: null,
          taskType: 'complete',
          continueLabel: 'Finish lesson!',
        },
      ],
    },
  ],
};

// ─────────────────────────────────────────────────────────────────
// LESSON 4 BONUS
// ─────────────────────────────────────────────────────────────────
export const LESSON_4_BONUS = {
  title: 'Bonus Round — Queen and King Mastery!',
  phases: [
    {
      id: 'bonus1',
      title: 'Queen and King Trivia',
      durationMins: 8,
      steps: [
        {
          id: 'b1', taskType: 'recap-quiz', boardState: 'empty', highlights: [],
          voice: `Bonus round, {name}! How many squares does the Queen reach from the centre of the board?`,
          recapQuestion: 'How many squares does the Queen reach from the centre?',
          recapOptions: ['Twenty-seven', 'Fourteen', 'Eight'],
          recapCorrect: 0,
          recapCorrectVoice: `TWENTY-SEVEN! Rook's fourteen plus Bishop's thirteen. The Queen is unstoppable from the centre!`,
          recapWrongVoice: `Twenty-seven! She combines the Rook's fourteen straight squares and the Bishop's thirteen diagonal squares.`,
          continueLabel: 'Next!',
        },
        {
          id: 'b2', taskType: 'recap-quiz', boardState: 'empty', highlights: [],
          voice: `How many squares can the King reach from the centre?`,
          recapQuestion: 'How many squares does the King reach from the centre?',
          recapOptions: ['Eight', 'Fourteen', 'Twenty-seven'],
          recapCorrect: 0,
          recapCorrectVoice: `Eight! One careful step in every direction. The King is short-range but the most important piece!`,
          recapWrongVoice: `Eight! The King takes just one step in any direction — eight neighbouring squares from the centre.`,
          continueLabel: 'Next!',
        },
        {
          id: 'b3', taskType: 'recap-quiz', boardState: '8/8/8/8/4Q3/8/8/8 w - - 0 1', highlights: ['e4'],
          voice: `The Queen is on e4 — a dark square. Can she ever reach a light square?`,
          recapQuestion: 'Is the Queen colour-locked like the Bishop?',
          recapOptions: ['No — she can visit any colour', 'Yes — she is colour-locked'],
          recapCorrect: 0,
          recapCorrectVoice: `Correct! The Queen is NOT colour-locked — she moves in straight lines too, which change the square colour. Only the Bishop is locked!`,
          recapWrongVoice: `No — the Queen is NOT colour-locked! She can visit any colour square because she moves in straight lines as well as diagonals.`,
          continueLabel: 'Next!',
        },
        {
          id: 'b4', taskType: 'recap-quiz', boardState: 'empty', highlights: [],
          voice: `From a CORNER, how many squares does the Queen reach?`,
          recapQuestion: 'How many squares does the Queen reach from a corner?',
          recapOptions: ['Twenty-one', 'Twenty-seven', 'Fourteen'],
          recapCorrect: 0,
          recapCorrectVoice: `Twenty-one! Six fewer than from the centre. The corner limits her diagonals — another reason to play from the centre!`,
          recapWrongVoice: `Twenty-one from a corner — six fewer than the centre's twenty-seven. The corner limits her diagonal reach.`,
          continueLabel: 'Next!',
        },
        {
          id: 'b5', taskType: 'recap-quiz', boardState: 'empty', highlights: [],
          voice: `Which piece moves like the Rook AND Bishop combined?`,
          recapQuestion: 'Which piece combines Rook and Bishop movement?',
          recapOptions: ['The Queen', 'The King', 'The Knight'],
          recapCorrect: 0,
          recapCorrectVoice: `The QUEEN! She moves in all eight directions — four straight like the Rook, four diagonal like the Bishop.`,
          recapWrongVoice: `The QUEEN! She moves like Rook and Bishop combined — straight lines AND diagonals in all eight directions.`,
          continueLabel: 'Next!',
        },
        {
          id: 'b6', taskType: 'recap-quiz', boardState: 'empty', highlights: [],
          pieceLetterRef: [
            { icon: '♕', letter: 'Q', name: 'Queen' },
            { icon: '♔', letter: 'K', name: 'King' },
            { icon: '♖', letter: 'R', name: 'Rook' },
          ],
          voice: `What is the Queen's letter in chess notation?`,
          recapQuestion: 'What letter does the Queen use?',
          recapOptions: ['Q', 'K', 'R'],
          recapCorrect: 0,
          recapCorrectVoice: `Q for Queen! K is for King, R is for Rook. Q for Queen — easy to remember!`,
          recapWrongVoice: `Q for Queen! K is King, R is Rook. Q always means the Queen.`,
          continueLabel: 'Next!',
        },
        {
          id: 'b7', taskType: 'recap-quiz', boardState: 'empty', highlights: [],
          pieceLetterRef: [
            { icon: '♔', letter: 'K', name: 'King' },
            { icon: '♘', letter: 'N', name: 'Knight' },
          ],
          voice: `What is the King's letter in chess notation?`,
          recapQuestion: 'What letter does the King use?',
          recapOptions: ['K', 'N', 'Q'],
          recapCorrect: 0,
          recapCorrectVoice: `K for King! And remember — N is the Knight, not the King, because King took K first!`,
          recapWrongVoice: `K for King! The Knight uses N — because the King already took K. K is always King.`,
          continueLabel: 'Next!',
        },
        {
          id: 'b8', taskType: 'recap-quiz', boardState: 'empty', highlights: [],
          voice: `The King can only move one square. But in which directions?`,
          recapQuestion: 'In which directions can the King move?',
          recapOptions: ['Any direction — up, down, left, right, and all diagonals', 'Only straight lines', 'Only diagonals'],
          recapCorrect: 0,
          recapCorrectVoice: `Any direction! The King moves one square in ANY of the eight directions. He is slow but versatile!`,
          recapWrongVoice: `Any direction! The King moves one square — but that one square can be in any of the eight directions around him.`,
          continueLabel: 'Speed Challenge!',
        },
      ],
    },
    {
      id: 'bonus2',
      title: 'Speed Square Challenge — Round 1',
      durationMins: 6,
      steps: [
        {
          id: 'bs1', taskType: 'speed-intro', boardState: 'empty',
          voice: `SPEED SQUARE CHALLENGE! I call squares — you find them as fast as you can. Ready? GO!`,
          continueLabel: 'Start challenge!',
        },
        {
          id: 'bs2', taskType: 'speed-round', boardState: 'empty',
          voice: `Speed challenge — find every square I call!`,
          timeLimitSecs: 90, targetCount: 20,
          successVoice: `Incredible! {score} squares found! You know this board inside out, {name}!`,
          completeVoice: `Time is up! You found {score} squares. Well done, {name}!`,
        },
      ],
    },
    {
      id: 'bonus3',
      title: 'Mixed Trivia — Lessons 1 Through 4',
      durationMins: 8,
      steps: [
        {
          id: 'b9', taskType: 'recap-quiz', boardState: 'empty', highlights: [],
          voice: `More questions! Which piece always stays on the same colour square?`,
          recapQuestion: 'Which piece is colour-locked for the whole game?',
          recapOptions: ['The Bishop', 'The Queen', 'The Rook'],
          recapCorrect: 0,
          recapCorrectVoice: `The BISHOP! Always on the same colour it started on. The Queen has no such restriction.`,
          recapWrongVoice: `The BISHOP is colour-locked — forever on the same colour it started on.`,
          continueLabel: 'Next!',
        },
        {
          id: 'b10', taskType: 'recap-quiz', boardState: 'empty', highlights: [],
          voice: `How many squares does a Rook control from anywhere on an empty board?`,
          recapQuestion: 'How many squares does a Rook always control on an empty board?',
          recapOptions: ['Fourteen', 'Eight', 'Twenty-seven'],
          recapCorrect: 0,
          recapCorrectVoice: `Fourteen! Always — corner, edge, or centre. The Rook never changes its count on an empty board!`,
          recapWrongVoice: `Fourteen! The Rook always controls exactly fourteen squares on an empty board, no matter where it stands.`,
          continueLabel: 'Next!',
        },
        {
          id: 'b11', taskType: 'recap-quiz', boardState: 'empty', highlights: [],
          voice: `How many squares are on a chess board in total?`,
          recapQuestion: 'How many squares total on a chess board?',
          recapOptions: ['64', '32', '48'],
          recapCorrect: 0,
          recapCorrectVoice: `64! Eight files times eight ranks equals sixty-four squares.`,
          recapWrongVoice: `64 squares — eight files times eight ranks.`,
          continueLabel: 'Next!',
        },
        {
          id: 'b12', taskType: 'recap-quiz', boardState: '8/8/8/8/8/8/8/3Q4 w - - 0 1', highlights: ['d1'],
          voice: `Where does the White Queen start in a real chess game?`,
          recapQuestion: 'Where does the White Queen start?',
          recapOptions: ['d1', 'e1', 'a1'],
          recapCorrect: 0,
          recapCorrectVoice: `d1! The White Queen starts on d1 — her own colour, a light square. The King is on e1 beside her.`,
          recapWrongVoice: `d1! The White Queen always starts on d1 — right next to the King on e1.`,
          continueLabel: 'Next!',
        },
        {
          id: 'b13', taskType: 'recap-quiz', boardState: 'empty', highlights: [],
          voice: `From the CORNER, how many squares does the KING reach?`,
          recapQuestion: 'How many squares does the King reach from a corner?',
          recapOptions: ['Three', 'Eight', 'Five'],
          recapCorrect: 0,
          recapCorrectVoice: `Three! The corner gives the King only three neighbours — the fewest of any square. Corner Kings are in danger!`,
          recapWrongVoice: `Three! The corner only has three neighbouring squares for the King to step to.`,
          continueLabel: 'Last question!',
        },
        {
          id: 'b14', taskType: 'recap-quiz', boardState: '8/8/8/8/4Q3/8/8/8 w - - 0 1', highlights: [],
          moveNotation: 'Qd5',
          moveExplain: 'Q = Queen moved to d5',
          voice: `What does the chess move "Qd5" mean?`,
          recapQuestion: 'What does "Qd5" mean?',
          recapOptions: ['The Queen moved to d5', 'The King moved to d5', 'A Pawn moved to d5'],
          recapCorrect: 0,
          recapCorrectVoice: `The Queen moved to d5! Q is always Queen, d5 is the destination square. You read chess notation perfectly!`,
          recapWrongVoice: `Q is for Queen — so Qd5 means the Queen moved to square d5.`,
          continueLabel: 'Speed Round 2!',
        },
      ],
    },
    {
      id: 'bonus4',
      title: 'Speed Square Challenge — Round 2',
      durationMins: 6,
      steps: [
        {
          id: 'bs3', taskType: 'speed-intro', boardState: 'empty',
          voice: `ROUND 2 — new squares, same challenge! Ready? GO!`,
          continueLabel: 'Start round 2!',
        },
        {
          id: 'bs4', taskType: 'speed-round', boardState: 'empty',
          voice: `Round 2 — find every square I call!`,
          timeLimitSecs: 90, targetCount: 20,
          successVoice: `AMAZING, {name}! Getting faster every round!`,
          completeVoice: `Round 2 complete! {score} squares found. You are unstoppable, {name}!`,
        },
      ],
    },
    {
      id: 'bonus5',
      title: 'Bonus Complete',
      durationMins: 1,
      steps: [
        {
          id: 'bend', taskType: 'complete', boardState: 'empty',
          voice: `{name}, you have been OUTSTANDING! You mastered the Queen and King, answered every question, and blazed through two speed rounds. Four pieces down — Rook, Bishop, Queen, and King. Next lesson: the Knight and Pawn. See you then!`,
          continueLabel: 'Finish Lesson 4!',
        },
      ],
    },
  ],
};
